<app-info-modal>
    <ng-container modal-header>
        <h5>{{ 'METER_READINGS' | translate }}</h5>
        <p class="u-font-size-small u-color-muted">{{ data.move.user?.formattedMovingAddress }}</p>
    </ng-container>

    <app-meter-info [data]="data" (success)="handleCloseMeterInfo($event)"></app-meter-info>
</app-info-modal>
